import {
  ViewId,
  User,
  UserAbility,
  UserOperationMode,
  RemoteConfigProperties
} from "@madhive/mad-sdk";
import { madSDK } from "lib/sdk";

export const getUserPermissions = (
  viewId: ViewId,
  abilities: UserAbility[]
) => {
  const userAbilitiesForViewId =
    viewId === ViewId.FIRST_PARTY_DATA_ONBOARDING
      ? abilities.find(item => item.resource === "pii")
      : abilities.find(item => item.resource === viewId);

  const canView = !!userAbilitiesForViewId?.operations.includes(
    UserOperationMode.READ
  );

  const canManage = !!userAbilitiesForViewId?.operations.includes(
    UserOperationMode.UPDATE
  );

  const readOnly = canView && !canManage;

  return { canView, canManage, readOnly };
};

export const isUserAbleToViewAgainstViewId = (viewId: ViewId, user: User) => {
  if (user.isDev) {
    return true;
  }

  // Special case: Allow FIRST_PARTY_DATA_ONBOARDING if Direct Upload flag is enabled
  if (viewId === ViewId.FIRST_PARTY_DATA_ONBOARDING) {
    try {
      const isDirectUploadEnabled = madSDK.featureFlags.isFlagEnabled(
        RemoteConfigProperties.DIRECT_1P_FILE_UPLOAD
      );
      if (isDirectUploadEnabled) {
        return true;
      }
    } catch (e) {
      // If remote config check fails, fall through to normal permission check
    }
  }

  if (!user.abilities) {
    return user.viewIds.includes(viewId);
  }

  const { canManage, canView } = getUserPermissions(viewId, user.abilities);

  return canView || canManage;
};
